(function (upp) {
    'use strict';

    upp.config(['$routeProvider',
        function ($routeProvider) {
            //Returns a promise that will check if 'about' module is config as active so its routes are available
            var resolver = {
                resolve: $routeProvider.ResolverFactory.moduleIsActivated("about").resolver
            };

            $routeProvider
                .when('/about', {
                    templateUrl: require('../templates/about.html'),
                    resolve: resolver,
                    showAd: true
                })
                .when('/about/contact', {
                    templateUrl: require('../templates/about-contact.html'),
                    resolve: resolver,
                    showAd: true
                })
                .when('/about/who', {
                    templateUrl: require('../templates/about-who.html'),
                    resolve: resolver,
                    showAd: true
                })
                .when('/about/where', {
                    templateUrl: require('../templates/about-where.html'),
                    resolve: resolver,
                    showAd: true
                })
                .when('/about/policy', {
                    templateUrl: require('../templates/about-policy.html'),
                    resolve: resolver,
                    showAd: true
                })
                .when('/about/rrss', {
                    templateUrl: require('../templates/about-rrss.html'),
                    resolve: resolver,
                    showAd: true
                });
        }]);

})(upp);


// WEBPACK FOOTER //
// ./src/app/modules/about/routes/about-routes.js